// @ts-nocheck

import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import { uiStateAction } from '../../../actions/app.action'
import { fetchAllProgramsCall } from '../../../actions/enrollment.action'
import {
  fetchPublicAggregateRatingsCall,
  fetchPublicRatingReviewStatus,
} from '../../../actions/reviewratings.action'
import AvailablePrograms from '../../../components/sis/student/availablePrograms/AvailablePrograms'
import { ROUTES } from '../../../helpers/constants'
import { selectMetaData, selectSchool, selectUiState, selectUser } from '../../../helpers/selectors'
import { getSchoolUrl, isEmpty, noop } from '../../../helpers/utils'
import withRouteContext from '../../../hocs/RouterContextHOC'
import withStudentDetails from '../../../hocs/withStudentDetailHOC'

function AllProgramsOpenContainer({
  uiState,
  uiStateAction,
  fetchAllProgramsCall,
  school,
  user,
  fetchPublicAggregateRatingsCall,
  fetchPublicRatingReviewStatus,
  metadata,
}) {
  const [availableProgramList, setAvailableProgramList] = React.useState([])
  const history = useHistory()
  const params = useParams()
  const [programRatings, setProgramRatings] = React.useState([])
  const [programReviewSettings, setProgramReviewSettings] = React.useState([])

  const fetchAllPrograms = function () {
    fetchAllProgramsCall(school.sch_id, { ...uiState.programsPageDetails }, (data) => {
      const { content, ...paginationDetail } = data
      setAvailableProgramList(content)
      const programsPageDetails = {
        ...uiState.programsPageDetails,
        last_page: paginationDetail.last_page,
        current_page: paginationDetail.current_page,
        from: paginationDetail.from,
        per_page: paginationDetail.per_page,
        to: paginationDetail.to,
        total: paginationDetail.total,
      }
      uiStateAction({ programsPageDetails })
    })
  }

  const onChangePage = function (event, newPage) {
    uiStateAction({
      programsPageDetails: { ...uiState.programsPageDetails, current_page: newPage },
    })
  }

  const fetchRatings = (programId) => {
    const queryParams = programId.map((id) => `pgm_id[]=${id}`).join('&')
    fetchPublicAggregateRatingsCall(
      queryParams,
      (data) => {
        setProgramRatings(data)
      },
      noop
    )
  }

  const checkRatingReviewStatusAndReviewSettings = (programIds) => {
    const queryParams = programIds.map((id) => `pgm_id[]=${id}`).join('&')
    fetchPublicRatingReviewStatus(
      queryParams,
      (data) => {
        setProgramReviewSettings(data)
      },
      noop
    )
  }

  const updatedProgramList = useMemo(() => {
    if (!availableProgramList?.length) {
      return availableProgramList
    }

    return availableProgramList.map((item) => {
      const matchingRating = programRatings.find((data) => item.pgm_id == data.pgm_id)
      const matchingReviewSetting = programReviewSettings.find((data) => item.pgm_id == data.pgm_id)

      return {
        ...item,
        aggregateRating: matchingRating ? matchingRating.aggregateRating : item.aggregateRating,
        totalRatings: matchingRating ? matchingRating.totalRatings : item.totalRatings,

        context_data: matchingReviewSetting
          ? {
              ...item.context_data,
              ...matchingReviewSetting.context_data,
            }
          : item.context_data,
      }
    })
  }, [availableProgramList, programRatings, programReviewSettings])

  const enrollProgram = (id) => {
    if (isEmpty(user)) {
      history.push(getSchoolUrl({ ...params, to: `${ROUTES.REGISTER}?pid=${id.toString()}` }))
    } else {
      history.push(
        getSchoolUrl({
          ...params,
          to: `${ROUTES.LOGIN}/auth?pid=${id}`,
        })
      )
    }
  }

  React.useEffect(() => {
    if (!isEmpty(school)) {
      fetchAllPrograms()
    }
  }, [school, uiState.programsPageDetails.current_page])

  React.useEffect(() => {
    if (isEmpty(availableProgramList)) {
      return
    }
    if (availableProgramList) {
      const ratingPgmIds = availableProgramList.map((item) => {
        return item.pgm_id
      })

      if (ratingPgmIds?.length) {
        fetchRatings(ratingPgmIds)
        checkRatingReviewStatusAndReviewSettings(ratingPgmIds)
        // fetchCourseRatings(cgiIdArray)
      }
    }
  }, [availableProgramList])

  /**
   * renders JSX of Program Courses container
   * @param AvailablePrograms
   */

  return (
    <AvailablePrograms
      availableProgramList={updatedProgramList}
      pageDetails={uiState.programsPageDetails}
      onChangePage={onChangePage}
      user={user}
      enrollProgram={enrollProgram}
      readOnlyMode={true}
      school={school}
      metadata={metadata}
    />
  )
}

AllProgramsOpenContainer.propTypes = {
  uiState: PropTypes.object,
  uiStateAction: PropTypes.func,
  fetchAllProgramsCall: PropTypes.func,
  school: PropTypes.object,
  user: PropTypes.object,
  fetchPublicAggregateRatingsCall: PropTypes.object,
  fetchPublicRatingReviewStatus: PropTypes.func,
  metadata: PropTypes.object,
}

AllProgramsOpenContainer.defaultProps = {
  uiState: {},
  uiStateAction: noop,
  fetchAllProgramsCall: noop,
  school: {},
  user: {},
  fetchPublicAggregateRatingsCall: noop,
  fetchPublicRatingReviewStatus: noop,
  metadata: {},
}

const mapStateToProps = (state) => ({
  school: selectSchool(state),
  uiState: selectUiState(state),
  user: selectUser(state),
  metadata: selectMetaData(state),
})

export default withStudentDetails(
  withRouteContext(
    connect(mapStateToProps, {
      uiStateAction,
      fetchAllProgramsCall,
      fetchPublicAggregateRatingsCall,
      fetchPublicRatingReviewStatus,
    })(AllProgramsOpenContainer)
  )
)
